import { ConfigProviderContext } from '@components/utils/config-provider'
import { useContext } from 'react'

export const Logo = () => {
  const context = useContext(ConfigProviderContext)

  return (
    <img
      src={context?.config?.logo || 'https://neurosys.com/wp-content/themes/neurosys/Assets/Images/logo-black.svg'}
      alt="NeuroSYS"
      height={50}
    />
  )
}
